import React, {useEffect, useState} from "react";
import {Card, CardBody, CardFooter, CardHeader, CardTitle, Col, Row} from "reactstrap";
import {Pie} from "react-chartjs-2";
import {dashboardEmailStatisticsChart} from "../../variables/charts";


function PieChart(props) {

    return (
        <>
            <Col md="6">
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5" className=" text-info"> <i className="fa fa-box text-info"/>  {props.title}</CardTitle>
                    </CardHeader>
                    <CardBody style={{height: "466px"}}>
                        <Pie
                            data={(canvas) => {
                                return {
                                    labels: [1, 2, 3],
                                    datasets: [
                                        {
                                            label: "Gender",
                                            pointRadius: 0,
                                            pointHoverRadius: 0,
                                            backgroundColor: props.colorChart,
                                            borderWidth: 0,
                                            data: props.dataChart,
                                        },
                                    ],
                                };
                            }}
                            options={dashboardEmailStatisticsChart.options}
                        />
                    </CardBody>
                    <CardFooter>
                        <hr/>
                        <div className="legend" style={{overflowX: 'auto'}}>   <i className="fa fa-users text-info"/> Total Active User : {props.totalUsers}<br/>
                            {props.property.map((prop,index) =>{
                                return (
                                    <span key={index}>
                                <i className="fa fa-circle " style={{color:props.colorChart[index]}}/> {prop.props.children[3]} : {prop.props.children[5]} &nbsp;
                                </span>
                                );
                            })}
                        </div>
                    </CardFooter>
                </Card>
            </Col>
        </>
    );
}

export default PieChart;